export enum MediaManagerRouteEnum {
  MEDIA_MANAGER = 'MediaManager',
  REVIEW = 'Review',
  BROADCAST_SCHEDULE = 'BroadcastSchedule',
  SEGMENTS = 'Segments',
  CLIPS = 'Clips',
  PROFILE = 'Profile',
}
